/* @ngInject */
export function AdministrationController($log, NavigationService) {
    var ctrl = this;

    ctrl.$onInit = function() {
        $log.debug('Administration::init');
        var navConfig = NavigationService.getNavConfig();
        ctrl.colorName = navConfig.colorName;
        ctrl.icon = navConfig.icon;
    };
}
